import {Grouping} from "@/core/interfaces/laboratory/Grouping";
import GroupingBranding from "@/core/interfaces/laboratory/GroupingBranding";

/**
 * The groupings resource.
 * @author Mathieu Bolard <m.bolard@apodispharma.com>
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client) {
    return {

        /**
         * Search for groupings.
         * @param {string} name - The name query.
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async search(name: string): Promise<{ groups: Grouping[] }> {
            return client
                .get('/grouping/search', {params: {name}})
                .then(response => response.data);
        },

        /**
         * Index of groupings.
         *
         * @returns {Promise} Promise object represents the HTTP request.
         */
        async index(): Promise<Grouping[]> {
            return client.get('/grouping-list')
                .then(response => response.data.data);
        },

        /**
         * Get the branding of a grouping.
         *
         * @param groupingId
         */
        async branding(groupingId: number): Promise<GroupingBranding> {
            return client.get(`groupings/${groupingId}/branding?include=sliders.type,sliders.type`)
                .then(response => response.data.groupingBranding);
        }
    };
}
